<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div class="container">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
        <div class="page-title sub">{{ title }}</div>
        <RuleBtn :type="type" />
      </div>
      <div class="marquee-box">
        <marquee
          id="affiche"
          align="left"
          behavior="scroll"
          direction="left"
          height="20"
          width="100%"
          vspace="10"
          loop="-1"
          scrollamount="5"
          scrolldelay="10"
          on-mouse-out="this.start()"
          on-mouse-over="this.stop()">
          {{ marqueeText }}
        </marquee>
      </div>
      <div class="detail-box" :class="'boxtype' + type">
        <div
          class="list1"
          v-if="list && list.length > 0 && listType === 'column'">
          <div
            class="item arrow"
            v-for="(item, index) in list"
            :key="index"
            @click="handleActivity(item)">
            <div class="flexable top">
              <div
                class="img"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.image + ')'
                }"></div>
              <div class="activity-info">
                <div
                  class="name"
                  v-if="item.category_id === 2 || item.category_id === 3">
                  {{ item.event_title }}
                </div>
                <div class="name" v-else>{{ item.name }}</div>
                <div class="date">
                  {{ item.started_at + ' - ' + item.opened_at }}
                </div>
                <div class="status-component" :class="'status' + item.status">
                  {{ item.statusName }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list2" v-if="list && list.length > 0 && listType === 'row'">
          <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            @click="handleNft(item)">
            <div
              class="img-box"
              :style="{
                backgroundImage: 'url(' + $store.state.imgUrl + item.image + ')'
              }"></div>
            <div class="av type2">{{ item.event_title }}</div>
          </div>
        </div>
        <div
          class="result-box ac"
          style="margin-top: 1.5rem"
          v-if="list && list.length === 0">
          <div class="h icons comming"></div>
          <div class="de">{{ $t('add.text83') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RuleBtn from '@/components/RuleBtn.vue'

export default {
  components: { RuleBtn },
  props: {
    from: {
      type: String,
      default: () => 'user'
    },
    api: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: () => ''
    },
    params: {
      type: Object,
      default: () => null
    },
    listType: {
      type: String,
      default: () => 'column'
    },
    type: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      list: null,
      marqueeText: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.api(this.params).then((res) => {
        this.marqueeText = res.data.top_bar
        if (res.data.lists) {
          this.list = res.data.lists.map((item) => {
            item.status = 1
            item.statusName = this.$t('inprogress')
            return item
          })
        } else {
          this.list = res.data.map((item) => {
            item.status = 1
            item.statusName = this.$t('inprogress')
            return item
          })
        }
      })
    },
    handleActivity(item) {
      if (this.from === 'user') {
        this.handleRoute('/user/activity', item)
      } else {
        this.handleRoute('/babe/actdetail', item)
      }
    },
    handleNft(item) {
      if (this.from === 'user') {
        this.handleRoute('/user/nftdetail', item)
      } else {
        this.handleRoute('/babe/hotnft', item)
      }
    },
    handleBack() {
      this.$router.back()
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ActListBox.vue